import { useAppSelector } from '@hooks/redux';

import { useTranslation } from 'react-i18next';
import DepositInfo from '@components/Deposits/DepositInfo';
import DepositList from '@components/Deposits/DepositList';

function Deposits() {
  const { t } = useTranslation();
  const depositList = useAppSelector(state => state.depositsReducer.depositList);

  return (
    <div className='flex justify-center'>
      <div className='lg:w-[1130px] w-full max-lg:px-4'>
        <div className='flex'>
          <div className='py-4 lg:py-8 w-full h-full bg-white mb-12'>
            <div className='flex justify-between'>
              <h1 className='text-xl font-medium color-active'>{t('Deposits')}</h1>
            </div>
            <div className='sm:grid lg:grid-cols-6 sm:grid-cols-8 gap-10'>
              <div className='lg:col-span-4 sm:col-span-5'>
                <DepositList itemsCount='20' defaultInfo={true} />
              </div>
              <div className='lg:col-span-2 sm:col-span-3'>
                {depositList?.results?.length > 0 ? (
                  <div className='max-sm:mt-5'>
                    <DepositInfo />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Deposits;
